// @flow
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
// material-ui
import Toggle from 'material-ui/Toggle';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import Paper from 'material-ui/Paper';
import SelectField from 'material-ui/SelectField';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ImagePhoto from 'material-ui/svg-icons/image/photo';
// mutation
import * as TVShowAddMutation from '../../mutations/TVShowAddMutation';
import * as TVShowEditMutation from '../../mutations/TVShowEditMutation';
// components
import TextCharCount from '../ui/charCounter';
import PopupGallery from '../media/PopupGallery';
import Preview from '../preview/Preview';
import { DefaultButton } from '../controls/button';
import PersonSelector from '../controls/PersonSelector';
import Icon from '../ui/icon/icon';
import toTranslit from "../../util/cyrillic-to-translit";

// style
import buttonStyle from '../ui/button';
import '../ui/form.css';
import { styles, formElement, paperStyle, colors, containerHeader } from '../../lib/styles';

type Props = {
    history: Object,
    match: Object,
    relay: Object,
    viewer: Object,
};

type State = {
    category: ?string,
    description: ?string,
    openMediaGallery: boolean,
    persons: ?Array<?{
        firstName: ?string,
        id: string,
        lastName: ?string,
        smallAvatar: ?string,
    }>,
	isProject: boolean;
	hideDescription: boolean;
    preview: {
        id?: string,
        filename?: string,
    },
    previewPicture: ?string,
    schedule: string,
    shortDescription: ?string,
    title: ?string,
	slug: string,
	slugChanged: boolean,
    state: string,
    order: number,
}

class TVShow extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        const { tvshow } = this.props.viewer;
        const isTVShow = tvshow !== null;
        this.state = {
            title: isTVShow ? tvshow.title : '',
			slugChanged: false,
			slug: isTVShow ? tvshow.slug : '',
			isProject: isTVShow ? tvshow.isProject : false,
			hideDescription: isTVShow ? tvshow.hideDescription : false,
            shortDescription: isTVShow ? tvshow.shortDescription : '',
            description: isTVShow ? tvshow.description : '',
            schedule: isTVShow ? tvshow.schedule : '',
            category: isTVShow ? tvshow.category : null,
            persons: (isTVShow && tvshow.authors !== null) ? tvshow.persons : [],
            previewPicture: (isTVShow && tvshow.previewPicture !== null) ?
                tvshow.previewPicture :
                null,
            preview: (isTVShow && tvshow.preview !== null) ? tvshow.preview : {},
            // открыть медагалерею
            openMediaGallery: false,
            state: isTVShow ? tvshow.state : 'available',
            order: isTVShow ? tvshow.order : 0,
        };
    }

    onStateChanged = (tvShowState: string) => {
        this.setState({ state: tvShowState });
    };

    insertMediaFile = (fileData) => {
        this.setState({
            preview: {
                id: fileData.id,
                filename: fileData.filename,
            },
        });
    };

    handleCloseGallery = () => {
        this.setState({ openMediaGallery: false });
    };

    save = () => {
        const callback = (error: ?Error, tvshowId: ?string) => {
            if (error != null) {
                alert('error saving tvshow');
                return;
            }

            if (tvshowId) {
                this.props.history.replace(`/shows/${tvshowId}`);
            }
        };

        const baseParams = {
            title: this.state.title,
			slug: this.state.slug,
			isProject: this.state.isProject,
			hideDescription: this.state.hideDescription,
            shortDescription: this.state.shortDescription,
            description: this.state.description,
            schedule: this.state.schedule,
            category: this.state.category,
            persons: this.state.persons.map(p => p.id),
            previewPicture: this.state.previewPicture,
            preview: this.state.preview,
            state: this.state.state,
        };

        if (baseParams.lead === '' || baseParams.title === '') {
            return;
        }

        baseParams.preview = this.state.preview &&
        Object.prototype.hasOwnProperty.call(this.state.preview, 'id') ?
            this.state.preview.id :
            '';

        console.log('base params');
        console.log(baseParams);

        const { tvshow } = this.props.viewer;
        if (tvshow !== null) {
            const params = {
                id: tvshow.id,
                ...baseParams,
                order: this.state.order,
            };
			delete params.slug;
            TVShowEditMutation.commit(this.props.relay.environment, params, callback);
        } else {
            TVShowAddMutation.commit(this.props.relay.environment, baseParams, callback);
        }
    };

    renderPreview = (img) => {
        let previewPath = img.previewPicture;
        let mediaId = '';
        if (img.preview && Object.prototype.hasOwnProperty.call(img.preview, 'filename')) {
            previewPath = img.preview.filename;
            mediaId = img.preview.id;
        }
        return (
            <div style={{ marginTop: 15 }}>
                <small style={formElement.smallTitle}>Обложка</small>
                <Icon icon="plus" />
                <IconButton
                    containerElement="label"
                    style={buttonStyle.icon_space}
                    className="btn__hover_empty"
                    onClick={() => (this.setState({ openMediaGallery: true }))}
                >
                    <ImagePhoto color={colors.default} hoverColor={colors.linkHover} />
                </IconButton>
                {previewPath && <Preview
                    type="small"
                    item={previewPath}
                    mediaId={mediaId}
                    removePreview={() => {
                        this.setState({
                            preview: {},
                            previewPicture: '',
                        });
                    }}
                />
                }
                <Divider style={formElement.divider} />
            </div>
        );
    };

	onTitleChanged = (newValue: string) => {
		if (this.state.slugChanged || this.props.viewer.tvshow) {
			this.setState({ title: newValue });
		} else {
			this.setState({
				title: newValue,
				slug: toTranslit(newValue),
			});
		}
	};

	onSlugChanged = (newValue: string) => {
		this.setState({
			slugChanged: true,
			slug: newValue,
		});
	};

    render() {
        const { categories } = this.props.viewer;
        const { category } = this.state;
        const newHistoryItem = `/epg/new?parent=${this.props.match.params.id}`;

        return (
            <section style={styles.twinPanes.wrapper}>
                <PopupGallery
                    open={this.state.openMediaGallery}
                    type={['image']}
                    closeDialogHandle={() => (this.setState({ openMediaGallery: false }))}
                    insertMediaFile={(item) => {
                        setTimeout(() => {
                            this.insertMediaFile(item);
                            this.handleCloseGallery();
                        }, 250);
                    }}
                    insertAfterUpload
                />
                <Paper style={paperStyle.mainItem}>
                    <header style={containerHeader.header}>
                        <h3 style={{
                            ...styles.headerTitle,
                            ...styles.twinPanes.headerTitle,
                        }}
                        >
                            Программа
                        </h3>
                        <FlatButton
                            style={styles.headerButton}
                            label="СОЗДАТЬ ВЫПУСК"
                            primary
                            icon={<ContentAdd />}
                            onClick={() => this.props.history.push(newHistoryItem)}
                        />
                    </header>

                    <TextField
                        floatingLabelText="Название"
                        style={formElement.textField}
                        floatingLabelStyle={formElement.label}
                        inputStyle={formElement.textFieldInput}
                        value={this.state.title}
                        fullWidth
                        errorText={(this.state.title === null || this.state.title.length === 0) ?
                            'это поле нужно заполнить' :
                            null}
						onChange={(event, value) => {
							this.onTitleChanged(value);
						}}
                        floatingLabelFixed
                    />
                    <TextCharCount
                        maxChar={90}
                        currentChar={this.state.title ? this.state.title.length : 0}
                    />

					<TextField
						hintText="Ссылка"
						floatingLabelText="Ссылка"
						value={this.state.slug || ''}
						maxLength="90"
						fullWidth
						disabled={Boolean(this.props.viewer.tvshow)}
						errorText={(this.state.title === null ||
							this.state.title.length === 0)
							? 'это поле нужно заполнить'
							: null}
						onChange={(event, value) => {
							this.onSlugChanged(value);
						}}
						floatingLabelFixed
					/>

                    <TextField
                        floatingLabelText="Короткое описание"
                        style={formElement.textField}
                        floatingLabelStyle={formElement.label}
                        inputStyle={formElement.textFieldInput}
                        value={this.state.shortDescription}
                        fullWidth
                        multiLine
                        rows={1}
                        rowsMax={2}
                        errorText={(this.state.shortDescription === null ||
                            this.state.shortDescription.length === 0) ?
                            'это поле нужно заполнить' :
                            null}
                        onChange={(e, v) => this.setState({ shortDescription: v })}
                        floatingLabelFixed
                    />
                    <TextCharCount
                        maxChar={250}
                        currentChar={this.state.shortDescription ?
                            this.state.shortDescription.length :
                            0}
                    />

                    <TextField
                        floatingLabelText="Полное описание"
                        style={formElement.textField}
                        floatingLabelStyle={formElement.label}
                        inputStyle={formElement.textFieldInput}
                        value={this.state.description}
                        fullWidth
                        multiLine
                        rows={1}
                        rowsMax={6}
                        errorText={(this.state.description === null ||
                            this.state.description.length === 0) ?
                            'это поле нужно заполнить' :
                            null}
                        onChange={(e, v) => this.setState({ description: v })}
                        floatingLabelFixed
                    />

                    {this.renderPreview(this.state)}

                    <TextField
                        hintText="Расписание"
                        floatingLabelText="Расписание"
                        value={this.state.schedule}
                        fullWidth
                        multiLine
                        rows={1}
                        rowsMax={6}
                        errorText={(this.state.schedule === null ||
                            this.state.schedule.length === 0) ?
                            'это поле нужно заполнить' :
                            null}
                        onChange={(e, v) => this.setState({ schedule: v })}
                        floatingLabelFixed
                    />

					<Toggle
						style={{ marginBottom: 10 }}
						toggled={this.state.isProject}
						label="Это проект"
						onToggle={(e, v) => this.setState({ isProject: v })}
					/>

					<Toggle
						style={{ marginBottom: 10 }}
						toggled={this.state.hideDescription}
						label="Скрыть описание"
						onToggle={(e, v) => this.setState({ hideDescription: v })}
					/>

                    <PersonSelector
                        value={this.state.persons}
                        source={this.props.viewer.persons.edges.map(e => e.node)}
                        onChange={persons => this.setState({ persons })}
                    />
                </Paper>

                <div style={styles.sidebar.default}>
                    <SelectField
                        style={styles.sidebar.selectField}
                        floatingLabelStyle={formElement.label}
                        floatingLabelText="Рубрика"
                        value={category}
                        errorText={(!category || category === '') && 'Рубрика необходима'}
                        onChange={(e, i, v) => this.setState({ category: v })}
                        dropDownMenuProps={{
                            iconButton: <Icon icon="triangle" />,
                            iconStyle: { marginTop: 4, marginRight: -21 },
                            style: { width: 273 },
                        }}
                    >
                        {
                            categories.edges.map(edge => edge.node).map(cat => (
                                <MenuItem key={cat.id} value={cat.id} primaryText={cat.name} />
                            ))
                        }
                    </SelectField>

                    <div className="button__bottom">
                        <SelectField
                            floatingLabelText="Статус программы"
                            value={this.state.state}
                            onChange={(event, index, state) => this.onStateChanged(state)}
                        >
                            <MenuItem value="available" primaryText="Доступно" />
                            <MenuItem value="archive" primaryText="Архив" />
                            <MenuItem value="deleted" primaryText="Удалено" />
                        </SelectField>
                        <DefaultButton onClick={this.save} />
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(createFragmentContainer(
    TVShow,
    graphql`
        fragment TVShow_viewer on Viewer @argumentDefinitions(id:{type:"ID!",}, section: {type:"ID!",}) {
            id,
            tvshow(id: $id) {
                id,
                title,
                slug,
                previewPicture,
				isProject,
				hideDescription,
                preview {
                    id,
                    filename
                },
                shortDescription,
                description,
                schedule,
                category,
                persons {
                    id,
                    firstName,
                    lastName,
                    smallAvatar,
                },
                state,
                order,
            },
            categories(section: $section) {
                edges {
                    node {
                        id,
                        name
                    }
                }
            },
            persons(first: -1, personType: "host") {
                edges {
                    node {
                        id,
                        firstName,
                        lastName,
                        smallAvatar
                    }
                }
            },
            me {
                id
            },
        }`,
));




// WEBPACK FOOTER //
// src/components/tvshow/TVShow.js